<template>
  <div class="row">
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>詢車資料</h4>
        </div>
        <div class="row">
          <h5 class="col-md-12 red_textcolor">
            ※備註: 接單時的情況，依照時間先後順序 (紅色為派遣司機)
          </h5>
          <table class="table">
            <thead>
              <tr>
                <th>隊編/呼號</th>
                <th>狀態</th>
                <th>回覆內容</th>
                <th>時間</th>
                <el-tooltip
                  class="tool-tip"
                  content="搶單當下與乘客的距離"
                  placement="top-start"
                >
                  <th>距離(公尺)</th>
                </el-tooltip>
              </tr>
            </thead>
            <tbody>
              <template v-for="inquiry_driver in inquiry">
                <tr
                  v-if="inquiry.length > 0"
                  :class="{ red_textcolor: inquiry_driver.get_order }"
                >
                  <td>
                    {{ inquiry_driver.driver_list.call_number }}
                  </td>
                  <td>{{ inquiry_driver.car_state }}</td>
                  <td>{{ inquiry_driver.drive_state }}</td>
                  <td>{{ inquiry_driver.createdAt }}</td>
                  <td>{{ inquiry_driver.distance }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inquiry: Array,
  },
}
</script>

<style scoped>
.tool-tip:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/transaction/components/Inquiry.vue